import styles from "components/event/EventDetailComponentLargeProductCardReview.module.scss";
import Image from "next/image";
import TruncateMarkup from "react-truncate-markup";
import {numberWithComma} from "common/utils";
import addOptionCountsToPouch from "api/addToPouch";
import OptionSelectorModal from "components/modal/OptionSelectorModal";
import {useContext} from "react";
import ModalContext from "context/ModalContext";
import ToastContext from "context/ToastContext";
import PouchContext from "context/PouchContext";
import UserContext from "context/AuthContext";
import {toast} from "react-toastify";
import PouchIcon from "images/icons/add_to_pouch.svg";
import StarRatingSmall from "components/review/StarRatingSmall";
import StarRatingLong from "components/review/StarRatingLong";
import ArrowRightIcon from "images/icons/arrow_right_757575_16.svg";
import Link from "next/link";
import {getProductRoute} from "common/const";


const EventDetailComponentLargeProductCardReview = (props) => {
    const {product, description, review} = props;

    const {openModal, closeModal} = useContext(ModalContext) || {};
    const toastContext = useContext(ToastContext);
    const pouchContext = useContext(PouchContext);
    const user = useContext(UserContext).user;

    const handleCloseOptionSelectorModal = () => {
        closeModal();
    };

    const onAddToPouchSuccessOverride = () => {
        const toastId = toast.info(
            '장바구니에 제품을 담았어요',
        );
        toastContext.registerToast(toastId);
        closeModal();
    };

    const addToPouch = (e) => {
        e.stopPropagation();
        e.preventDefault();
        toastContext.closeToast();
        const options = product.options;
        if (options.length === 1) {
            const [referralId, referralPostId] = [null, null];
            const pouchOptions = [
                {
                    option_id: parseInt(options[0].id),
                    count: 1,
                    referral_id: referralId,
                    referral_post_id: referralPostId,
                    price: options[0].discounted_price
                }
            ];
            addOptionCountsToPouch(pouchOptions, user != null, onAddToPouchSuccessOverride, pouchContext,
                false, product.id, product.name);
        } else {
            openModal(() => {
                return <OptionSelectorModal
                    product={product} isModalOpen={true}
                    close={handleCloseOptionSelectorModal}
                    buttonText={"장바구니 담기"}
                    onAddToPouchSuccessOverride={onAddToPouchSuccessOverride}
                    isPouchForced
                />
            });
        }
    };

    return (
        <div className={styles.root}>
            <Link href={getProductRoute(product.id)}>
                <div className={styles.container}>
                    <div className={styles.imageContainer}>
                        <Image layout="fill" unoptimized objectFit="cover" src={product.image_url} />
                        <div className={styles.pouchButton} onClick={addToPouch}>
                            <PouchIcon width="32" height="32" viewBox="0 0 30 30" />
                        </div>
                    </div>
                    <div className={styles.infoContainer}>
                        <TruncateMarkup maxLines={1} ellipsis={<span>...</span>}>
                            <div className={styles.productName}>
                                {product.name}
                            </div>
                        </TruncateMarkup>
                        <div>
                            <div className={styles.scoreContainer}>
                                <StarRatingSmall rate={product.review_score} noParenthesis size={12} gap={4} fontSize={12} color={'white'} brandStar />
                                <span className={styles.reviewCount}>&nbsp;{`(리뷰 ${numberWithComma(product.review_count + product.mall_review_count)})`}</span>
                            </div>
                        </div>
                    </div>
                    {
                        !!review &&
                        <div className={styles.reviewContainer}>
                            {
                                !!review.images && review.images.length > 0 &&
                                <div className={styles.reviewPhotoContainer}>
                                    <Image layout="fill" unoptimized objectFit="cover" src={review.images[0].image_url} />
                                </div>
                            }
                            <div className={styles.reviewInfoContainer}>
                                <div className={styles.reviewInfoScoreContainer}>
                                    {
                                        !!review.masked_username &&
                                        <span className={styles.reviewWriter}>{review.masked_username}</span>
                                    }
                                    <StarRatingLong size={10.26} margin={0} rate={review.score} brandStar/>
                                </div>
                                <div className={styles.reviewContent}>
                                    <span>{review.content}</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Link>
            <Link href={`${getProductRoute(product.id)}#review`}>
                <div className={styles.link}>
                    <div className={styles.linkIcon}>

                    </div>
                    <div className={styles.linkText}>
                        리뷰 보러 가기
                    </div>
                    <div className={styles.linkIcon}>
                        <ArrowRightIcon viewBox="0 0 16 16" className={styles.linkArrow} />
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default EventDetailComponentLargeProductCardReview;
